// document ready
$(function () {
  const serverIp = "mc.voltyum.net";
  const serverPort = "25565";
  const discordServerId = "805935469996015616";
  const discordInvite = "https://discord.voltyum.net";

  Promise.all([
    $.getJSON("https://mcapi.us/server/status?ip=" + serverIp + "&port=" + serverPort),
    $.getJSON("https://discordapp.com/api/servers/" + discordServerId + "/widget.json"),
  ]).then(function (data) {
    const mcPlayers = data[0].players.now;
    const discordMembers = data[1].presence_count;

    $("#minecraft-count").text(mcPlayers + " jugadores online");
    $("#discord-count").text(discordMembers + " miembros online");

    // Give both element an opacity of 1
    $("#minecraft-count").css("opacity", "1");
    $("#discord-count").css("opacity", "1");
  });

  // Copy the server ip to the clipboard when the user clicks the "minecraft-section" element
  // Also we will add a little confirmation dialog
  $("#minecraft-section").click(function () {
    navigator.clipboard.writeText(serverIp).then(
      function () {
        $("#minecraft-section").attr("data-hover", "¡Copiado!");
        setTimeout(function () {
          $("#minecraft-section").attr("data-hover", "¡Click para copiar!");
        }, 2000);
      },
      function () {
        $("#minecraft-section").attr("data-hover", "Error al copiar!");
        setTimeout(function () {
          $("#minecraft-section").attr("data-hover", "¡Click para copiar!");
        }, 2000);
      }
    );
  });

  // Open the discord invite link in a new tab when the user clicks the "discord-section" element
  $("#discord-section").click(function () {
    window.open(discordInvite, "_blank");
  });
});
